<template>
        <div class="container">
                <h1>Minhas Inscrições</h1>

                <div v-if="error" class='alert alert-danger'>
                        {{ error }}
                </div>
                <div v-if="!purshaseProducts || !purshaseProducts.length">
                        <div class="alert alert-info">
                                <p>Você ainda não possui nenhuma inscrição.</p>
                                <p> <a href="/"> Clique aqui para se cadastrar em algum evento.</a> </p>
                        </div>
                </div>

                <template v-else>
                        <!-- Evento atual (maior eventId) — sempre visível -->
                        <div v-if="currentGroup">
                                <h3 style="color:#777777">{{ currentGroup.name }}</h3>
                                <hr/>
                                <my-purshase-product v-for="(product,index) in currentGroup.items"
                                        :purshaseProduct="product"
                                        :index="index+1"
                                        :gpx-open="gpxOpenFor(product.eventId)"
                                        :gpx-count="gpxCountFor(product)"
                                        :results-published="eventFlag(product.eventId, 'resultsPublished')"
                                        :certificate-enabled="eventFlag(product.eventId, 'certificateEnabled')"
                                        :key="'pp'+product.id"
                                        v-to="'/myregistrations/'+product.id">
                                </my-purshase-product>
                        </div>

                        <!-- Eventos anteriores — cada um num acordion colapsado -->
                        <div v-if="pastGroups.length" class="past-events">
                                <h3 style="color:#999999">Eventos anteriores</h3>
                                <div v-for="g in pastGroups" :key="'grp'+g.eventId" class="past-event">
                                        <button type="button" class="past-event-header" @click="toggle(g.eventId)">
                                                <span>{{ g.name }} <small class="o-60">({{ g.items.length }})</small></span>
                                                <span class="chev">{{ openGroups[g.eventId] ? '▲' : '▼' }}</span>
                                        </button>
                                        <b-collapse :visible="!!openGroups[g.eventId]">
                                                <div class="past-event-body">
                                                        <my-purshase-product v-for="(product,index) in g.items"
                                                                :purshaseProduct="product"
                                                                :index="index+1"
                                                                :gpx-open="gpxOpenFor(product.eventId)"
                                                                :gpx-count="gpxCountFor(product)"
                                        :results-published="eventFlag(product.eventId, 'resultsPublished')"
                                        :certificate-enabled="eventFlag(product.eventId, 'certificateEnabled')"
                                                                :key="'pp'+product.id"
                                                                v-to="'/myregistrations/'+product.id">
                                                        </my-purshase-product>
                                                </div>
                                        </b-collapse>
                                </div>
                        </div>
                </template>
        </div>
</template>


<script>
import api from '@/api';

export default {

        data(){
                return { error:false, gpxByEvent:{}, gpxCountByPp:{}, openGroups:{} }
        },
        created:async function(){
                let res = await this.$store.dispatch('PurchaseStore/loadMyRegistrations',this.$route.params.id)
                if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
                await Promise.all([this.loadGpxWindows(), this.loadGpxUploads()])
        },
        watch: {
                id:async function(){
                        this.error = false;
                        let res = await this.$store.dispatch('PurchaseStore/loadMyRegistrations',this.$route.params.id)
                        if(res == false){
                                this.error = "Ocorreu um Erro!"
                        }
                }
        },
        computed:{
                id:function(){
                        return this.$route.params.id
                },
                purshaseProducts:function(){
                        return this.$store.getters['PurchaseStore/myRegistrations']
                },
                // Grupos de evento ordenados por eventId desc (mais novo primeiro).
                eventGroups:function(){
                        let groups = {}
                        ;(this.purshaseProducts || []).forEach(pp => {
                                let name = pp.name.replace(/^([^\/]*?)\/.*/,'$1')
                                if(!groups[name]) groups[name] = { name, eventId:0, items:[] }
                                groups[name].items.push(pp)
                                groups[name].eventId = Math.max(groups[name].eventId, Number(pp.eventId) || 0)
                        })
                        return Object.values(groups).sort((a,b) => b.eventId - a.eventId)
                },
                currentGroup:function(){
                        return this.eventGroups[0] || null
                },
                pastGroups:function(){
                        return this.eventGroups.slice(1)
                }
        },

        methods: {
                toggle(eventId){
                        this.$set(this.openGroups, eventId, !this.openGroups[eventId])
                },

                // Janela de GPX por evento (para saber quais cards podem enviar).
                async loadGpxWindows() {
                        const ids = [...new Set((this.purshaseProducts || [])
                                .map(p => p.eventId).filter(Boolean))];
                        const map = {};
                        await Promise.all(ids.map(async (eid) => {
                                const ev = await api.getJSONAsync('events/' + eid);
                                if (ev && !ev.error) map[eid] = ev;
                        }));
                        this.gpxByEvent = map;
                },
                gpxOpenFor(eventId) {
                        const ev = this.gpxByEvent[eventId];
                        if (!ev || !ev.uploadGPX) return false;
                        const now = Date.now();
                        const open = ev.gpxUploadOpenAt ? new Date(ev.gpxUploadOpenAt).getTime() : 0;
                        const close = ev.gpxUploadCloseAt ? new Date(ev.gpxUploadCloseAt).getTime() : Infinity;
                        return now >= open && now <= close;
                },

                // Contagem de tracklogs já enviados por inscrição (via equipe).
                async loadGpxUploads() {
                        const map = {};
                        await Promise.all((this.purshaseProducts || []).map(async (pp) => {
                                const teamId = pp.team && pp.team[0] && pp.team[0].id;
                                if (!teamId) { map[pp.id] = 0; return; }
                                try {
                                        const rows = await api.getJSONAsync('gpxListForTeam', { teamId });
                                        map[pp.id] = Array.isArray(rows) ? rows.length : 0;
                                } catch (e) { map[pp.id] = 0; }
                        }));
                        this.gpxCountByPp = map;
                },
                // Flag booleana do evento já carregado em gpxByEvent (resultsPublished, certificateEnabled...).
                eventFlag(eventId, key) {
                        const ev = this.gpxByEvent[eventId];
                        return !!(ev && ev[key] === true);
                },
                gpxCountFor(pp) {
                        const v = this.gpxCountByPp[pp.id];
                        return v === undefined ? null : v;
                },
        }

}
</script>

<style scoped>
.past-events {
        margin-top: 2em;
}
.past-event {
        margin-bottom: 0.6em;
}
.past-event-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.7em 1em;
        background: #f1f3f5;
        border: 1px solid #e0e3e6;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 600;
        color: #555;
}
.past-event-header:hover {
        background: #e9ecef;
}
.past-event-header .chev {
        font-size: 0.75em;
        color: #999;
}
.past-event-body {
        padding-top: 0.8em;
}
.o-60 {
        opacity: 0.6;
        font-weight: 400;
}
</style>
